(function($){



  // toggle to expand or collapse the playlist in individual video page
  $(".btn_toggle").click(function(){
      $(".post_wrap").toggleClass("is_collapsed");
  });


  // Search
  var $search_icon = $('.search .icon-search');

  $('html,.search .icon-search-close').click(function() {
      $('body').removeClass("is_showsearch");
      $search_icon.removeClass("icon-search-close");
      $search_icon.addClass("icon-search");

  });

  // var show_search_results = function() {
  //
  // };
  $("#search-input").click(function(event){
    event.stopPropagation();
    $("body").addClass("is_showsearch");
    $search_icon.removeClass("icon-search");
    $search_icon.addClass("icon-search-close");
  });
  // $("input#search-input").focus(function() {
  //       show_search_results();
  // });




  // nav
  $("#home .nav_item").click(function(){
      var $this = $(this);
      var $index = $(this).index();
      var $playlist = $("#home .post_playlist_ul");


      $this.siblings().removeClass("is_current");
      $this.addClass("is_current");
      $playlist.hide();
      $playlist.eq($index).fadeIn('200');
  });

  var $window_width = $('body').innerWidth();
  if ($window_width < 661) {
    $("#home .nav_item").click(function(){
        $("body").addClass("nav_expand");
    });
    $(".home_wrap_playlist .btn-back").click(function(){
        $("body").removeClass("nav_expand");
    });
    // $(".post_wrap").removeClass("is_collapsed");
  }
  else {
    // if desktop, add is_current to the first child of the nav
    $("#home .nav_item").first().addClass("is_current");
    $("#home .post_playlist_ul").first().show();

    // $(".post_wrap").addClass("is_collapsed");
  }


  // press spacebar to pause or resume the video
  $(window).keypress(function(e) {
    // var video = document.getElementById("video");
    var video = $('#video')[0];
    if ($('#video').length > 0) {
      if (e.which == 32) {
        if (video.paused == true)
          video.play();
        else
          video.pause();
      }
    }
  });

})(jQuery);
